import httpClient from "./httpClient";

export function listDivisions() {
  return httpClient.get("/locations/divisions").then((res) => res.data.data);
}

export function listDistrictsByDivision(divisionId) {
  return httpClient.get("/locations/districts/by-division", { params: { divisionId } }).then((res) => res.data.data);
}

export function listThanasByDistrict(districtId) {
  return httpClient.get("/locations/thanas/by-district", { params: { districtId } }).then((res) => res.data.data);
}

export function listPostOfficesByThana(thanaId) {
  return httpClient.get("/locations/post-offices/by-thana", { params: { thanaId } }).then((res) => res.data.data);
}
